/**
 * Hook for webpack to build browser test-suite
 * Add new tests here
 */
import './accountPreferences.test.js';
import './applicationClass.test.js';
import './apptemplatesRequest.test.js';
import './bridgeAccess.test.js';
import './conversions.test.js';
import './datasetTemplate.test.js';
import './errors.test.js';
import './eventToShortText.test.js';
import './formatEventDate.test.js';
import './hdsLib.test.js';
import './hdsModel.test.js';
import './HDSProfile.test.js';
import './HDSSettings.test.js';
import './libSettings.test.js';
import './localizeText.test.js';
import './logger.test.js';
import './MonitorScope.test.js';
import './reminders.test.js';
import './cyclePhase.test.js';
import './temperatureShift.test.js';
import './cmcScope.test.js';
import './permissionLabels.test.js';
import './legacyChat.test.js';
import './toolkitStreamAutoCreate.test.js';
import './toolkitStreamsTools.test.js';
